<template>
    <div class="tutorial page">
        <div class="container">
            <h1 v-html="text.title"></h1>
            <div class="content" v-html="text.content"></div>
            
            <div class="last-row">
                <img :src="`${app_path}/images/tutorial.png`" alt="Tutorial">
                <router-button mode="primary" to="game">{{ text.button_okay }}</router-button>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import RouterButton from '@/components/RouterButton.vue'

export default {
    name: 'tutorial',
    components: {
        RouterButton
    },
    data: function() {
        return {
            text: window.config.text.tutorial,
            app_path: window.APP_PATH,
        };
    }
}
</script>

<style lang="scss">
.container {
    background-color: #fff;
    border-radius: 12px;
    padding:30px 30px 0;
    margin: 10px auto;
    max-width: 408px;
    width: calc(100% - 20px);
    font-family: 'Oswald-Light', sans-serif;
    box-sizing: border-box;

    h1 {
        text-align: center;
        margin:0;
        font-weight: normal;
    }
    .content {
        font-size: 18px;
        margin-bottom: 40px;
    }

    .router-button {
        background-color: #eae0d4;
        color: #a29585;
    }

    .last-row {
        display: flex;
        flex-direction: row;
        align-items: center;

        img {
            order: 1;
        }
        .router-button {
            order: 2;
            max-height: 64px;
            width: 50%;
        }
    }
}
</style>
